export const toApiPage = (page) => {
  const pageIndex = Number(page);
  return Number.isFinite(pageIndex) && pageIndex >= 0 ? Math.floor(pageIndex) + 1 : 1;
};
